import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { lineItemNoteBrands } from 'shared/constants';
import { FormTextField, NumberTextField } from 'shared/controls';
import { Brands, TCustomProductForm } from 'shared/types';

export function NewCustomProductDialogFields() {
  const {
    formState: { errors },
  } = useFormContext<TCustomProductForm>();
  const { brand } = useParams<{ brand: Brands }>();

  const isLineItemNoteBrand: boolean = lineItemNoteBrands.includes(brand);

  return (
    <Grid container spacing={1} pt={1}>
      <Grid xs={12} item>
        <FormTextField
          name='customProductName'
          label='Product'
          rules={{
            required: { message: 'Product is required', value: true },
          }}
          error={Boolean(errors?.customProductName)}
          helperText={errors?.customProductName?.message}
        />
      </Grid>
      <Grid xs={12} item>
        <NumberTextField
          name='customProductQuantity'
          label='Quantity'
          rules={{
            required: {
              message: 'Quantity is required',
              value: true,
            },
            min: {
              message: 'Quantity must be greater than 0',
              value: 1,
            },
          }}
          decimalScale={2}
          error={Boolean(errors?.customProductQuantity)}
          helperText={errors?.customProductQuantity?.message}
        />
      </Grid>
      <Grid xs={12} item>
        <NumberTextField
          name='customProductPrice'
          label='Price'
          rules={{
            required: {
              message: 'Price is required',
              value: true,
            },
            min: {
              message: 'Price must be greater than 0',
              value: 0.001,
            },
          }}
          decimalScale={2}
          error={Boolean(errors?.customProductPrice)}
          helperText={errors?.customProductPrice?.message}
        />
      </Grid>
      {isLineItemNoteBrand && (
        <Grid xs={12} item>
          <FormTextField name='lineItemNotes' label='Line Item Notes' multiline minRows={2} />
        </Grid>
      )}
    </Grid>
  );
}
